export const state = () => ({
  route: window.location.href,
});

export const getters = {
  currentRoute: (localstate) => localstate.route,
};

export const mutations = {
  SET_ROUTE(localstate, route) {
    localstate.route = route;
  },
};

export const actions = {
  setRoute({ commit }, route) {
    commit('SET_ROUTE', route);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
